import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useTotemSectorActions } from '../hooks';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useTicketFlowModals } from '../context';

interface CallNextButtonProps {
  buttonVariant?: GlobalButtonVariant;
}

const CallNextButton = ({
  buttonVariant = GlobalButtonVariant.primaryButton,
}: CallNextButtonProps) => {
  const { ticketData, setTicketData } = useTicketFlowModals();

  const { onCallNext, isLoadingCallNext } = useTotemSectorActions();

  const onCallNextCustomer = async () => {
    if (!ticketData) return;
    const data = await onCallNext(ticketData.sectorId);
    if (data) {
      setTicketData(data);
    }
  };

  return (
    <GlobalButton
      variant={buttonVariant}
      action={onCallNextCustomer}
      disabled={isLoadingCallNext}
    >
      <NotificationsIcon />
      Llamar siguiente
    </GlobalButton>
  );
};

export default CallNextButton;
